import React, { useEffect, useState } from "react"
import { getEnabledFeatures } from "../../components/Helper"
import Page404 from "../../pages/auth/Page404"

interface Props {
  feature: string
  children: React.ReactNode
}

const FeatureGuard = ({ feature, children }: Props) => {
  const [features, setFeatures] = useState<string[] | null>(null)

  useEffect(() => {
    let active = true
    getEnabledFeatures().then((list) => {
      if (active) setFeatures(list)
    })
    return () => {
      active = false
    }
  }, [])

  if (features === null) return null
  return features.includes(feature) ? <>{children}</> : <Page404 />
}

export default FeatureGuard
